import { pxToRem } from "@/util/common";
import { Popup, Image } from "antd-mobile";
import { createUseStyles } from "react-jss";
import useCustomTranslation from "@/hooks/useTranslation";
import { PayChannel } from "@/pages/Game/type";

const SelectorPopup: React.FC<{
	visible: boolean;
	data: PayChannel[];
	onClose?: () => void;
	onSelect: (index: number) => void;
}> = (props) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	return (
		<Popup
			bodyStyle={{
				borderTopLeftRadius: pxToRem(30),
				borderTopRightRadius: pxToRem(30),
			}}
			maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
			bodyClassName={classes.popupContent}
			visible={props.visible}
			closeOnMaskClick
			onClose={props.onClose}
		>
			<h2 className={classes.title}>{t("SelectCurrency")}</h2>
			<ul className={classes.list}>
				{props.data.map((item, index) => (
					<li onClick={() => props.onSelect(index)} key={item.code}>
						<Image
							src={item.logo}
							className="icon"
							style={{ borderRadius: "100%" }}
							fallback={
								<Image
									src={require("@/assets/images/icons/Avatar.png")}
									className="icon"
								/>
							}
						/>
						<span>{item.network}</span>
					</li>
				))}
			</ul>
		</Popup>
	);
};

export default SelectorPopup;

const useStyles = createUseStyles({
	popupContent: {
		backgroundColor: "#22293F",
		color: "#FFFFFF",
		paddingBottom: pxToRem(42),
	},
	title: {
		padding: `${pxToRem(18)} 0`,
		fontSize: pxToRem(18),
		fontWeight: 700,
		textAlign: "center",
	},
	list: {
		padding: {
			left: pxToRem(24),
			right: pxToRem(24),
		},
		"& li": {
			display: "flex",
			alignItems: "center",
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: 500,
			padding: pxToRem(20),
			borderRadius: pxToRem(10),
			marginBottom: pxToRem(5),
			backgroundColor: "#181D2C",
			"& .icon": {
				width: pxToRem(24),
				height: pxToRem(24),
				marginRight: pxToRem(16),
			},
			"&:active": {
				opacity: 0.8,
			},
		},
	},
});
